import {
  type StepItemType,
  // type FieldDetailsType,
  type PlotCardDetaillsInterface,
} from "./types";
import plotCardIcon1 from "../../assets/images/PlotCardIcon1.svg";
import plotCardIcon2 from "../../assets/images/PlotCardIcon2.svg";
import plotCardIcon4 from "../../assets/images/PlotCardIcon4.svg";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../shared/utils/translationUtils";

export const PlotDesigns = (): any => {
  const { t } = useTranslation();
  const PlotCardDetails: PlotCardDetaillsInterface[] | any = [
    {
      id: 1,
      icon: plotCardIcon1,
      name: "A/B Line + Machinery Grid",
      key: "ab_line",
      description: formatTranslation(t("trials.plotDesign.abLine")),
    },

    {
      id: 3,
      icon: plotCardIcon2,
      name: "Buffer Zone",
      key: "buffer_zone",
      description: formatTranslation(t("trials.plotDesign.bufferZone")),
    },
    {
      id: 4,
      icon: plotCardIcon4,
      name: "Trial Plots",
      key: "trial_plots",
      description: formatTranslation(t("trials.plotDesign.trialPlots")),
    },
  ];
  return PlotCardDetails;
};

export const useStep = (isStripe?: boolean): StepItemType[] => {
  const { t } = useTranslation();
  return [
    {
      title: formatTranslation(t("createProtocol.headerTitle")),
    },
    {
      title: formatTranslation(
        t(
          isStripe
            ? "newTrial.plotDesign.title.strips"
            : "newTrial.plotDesign.title.plots"
        )
      ),
    },
    {
      title: formatTranslation(t("createProtocol.headerTitleRates")),
    },
    {
      title: formatTranslation(t("newTrial.summary.title")),
    },
  ];
};

export const useMenuItems = (): Array<{ label: string; key: string }> => {
  const { t } = useTranslation();
  return [
    {
      label: formatTranslation(t("trials.saveAndShareReport")),
      key: "saveandsharereport",
    },
    {
      label: formatTranslation(t("trials.saveAndExportWorkOrder")),
      key: "openModel",
    },
  ];
};
